import React from 'react';
import StyledLink from './styles';
const SkipToContent = ({
  href = '#main-content'
} = {}) => /*#__PURE__*/React.createElement(StyledLink, {
  className: "sr-focusable",
  href: href
}, "Skip to content");
export default SkipToContent;
//# sourceMappingURL=index.js.map